/* eslint-disable max-len */
import loadable from '@loadable/component';
import { find as findExternalServices } from 'redux/modules/externalServices';
import { find as findServiceConsignees } from 'redux/modules/serviceConsignees';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'redi... Remove this comment to see the full error message
import provideHooks from 'redial/lib/provideHooks';
import LoadingComponent from 'components/Loaders/LoadingComponent';
import { batch } from 'react-redux';

const ServicesLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-services' */ './Services'),
  {
    fallback: <LoadingComponent />,
  }
);

const Services = (prop: any) => <ServicesLoadable {...prop} />;

export default provideHooks({
  fetch: async ({ store: { getState, dispatch } }: any) => {
    const promises: any = [];

    const state = getState();
    const externalServices = state.externalServices.result.allServices;
    const serviceConsignees = state.serviceConsignees.result.all;

    if (!externalServices) {
      promises.push(() =>
        dispatch(
          findExternalServices('allServices', {
            query: {
              $paginate: false,
            },
          })
        ).catch(console.error)
      );
    }
    if (!serviceConsignees) {
      promises.push(() =>
        dispatch(
          findServiceConsignees('all', {
            query: {
              $paginate: false,
            },
          })
        ).catch(console.error)
      );
    }

    // just one reflow call
    await new Promise((resolve) => {
      batch(async () => {
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'func' implicitly has an 'any' type.
        const finalPromises = promises.map((func) => func());
        await Promise.all(finalPromises);
        // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
        resolve();
      });
    });
  },
})(Services);
